import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const BROWARDTRAINSTOP_LAYER_ID = 'browardTrainStopLayer';

const ICONS = {
  'Train Stop': require('../../../assets/train.png'),
};

const layerConfig = {
  title: 'Train stops',
};

function BrowardTrainStopLayer() {
  const dispatch = useDispatch();
  const { browardTrainStopLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardTrainStopLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardTrainStopLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDTRAINSTOP_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardTrainStopLayer.visible,
      opacity: browardTrainStopLayer.opacity,

      pointType: 'icon',
      getIcon: (d) => {
        return {
          url: ICONS['Train Stop'],
          width: 128,
          height: 128,
          anchorY: 128,
        };
      },
      getIconSize: () => 12,
      iconSizeUnits: 'pixels',
      iconSizeScale: 2,
      iconBillboard: true,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDTRAINSTOP_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              title: 'Train Stop Details',
              includeColumns: [
                'Transit_Type',
                'Location_Name',
                'Location_Type',
                'Stop_Route_IDs',
              ],
            }),
          };
        }
      },
    });
  }
}

export default BrowardTrainStopLayer;
